import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Card from "components/card";
import Button from "components/button";
import { getAnnouncement } from "services/announcements";

const UserAnnouncementShow = () => {
  const { id } = useParams();
  const [announcement, setAnnouncement] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      if (!id) return;
      try {
        const { data } = await getAnnouncement(id);
        setAnnouncement(data?.data || data);
      } catch (err) {
        console.error(err);
        setAnnouncement(null);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  return (
    <Card extra="w-full p-4">
      {loading ? (
        <div>Loading...</div>
      ) : !announcement ? (
        <div className="text-gray-500">Announcement not found.</div>
      ) : (
        <div>
          <div className="mb-4 flex flex-col items-start justify-between md:flex-row md:items-center">
            <div>
              <h1 className="text-2xl font-bold">{announcement.title || announcement.name}</h1>
              <div className="mt-1 text-sm text-gray-400">
                {announcement.created_at ? new Date(announcement.created_at).toLocaleString() : ""}
                {announcement.creator ? (
                  <span className="ml-3 text-sm text-gray-500">by {announcement.creator.firstname || announcement.creator.name || announcement.creator.email}</span>
                ) : null}
              </div>
            </div>
            <div className="mt-3 md:mt-0">
              <Button as="link" to="/announcements" variant="outline" size="sm">
                Back
              </Button>
            </div>
          </div>
          <div className="prose dark:prose-invert max-w-none">
            <p>{announcement.body ?? announcement.content ?? announcement.description}</p>
          </div>
        </div>
      )}
    </Card>
  );
};

export default UserAnnouncementShow;
